import roundingNo from '../resources/no/rounding.json';
import roundingSe from '../resources/se/rounding.json';
import { RoundingLanguageResources } from '../types/RoundingResources';

export const roundingI18nResources: RoundingLanguageResources = {
  no: { rounding: roundingNo },
  se: { rounding: roundingSe },
};
